import { Select, Text } from "@mantine/core"
import { useTranslation } from "react-i18next"

export type GroupByOption = {
  key: string
  label: string
}

type Props = {
  options: GroupByOption[]
  active: string | null
  onChange: (key: string | null) => void
}

const NONE = "__none__"

/** «Бүлэглэх» select with an inline label; the first option is «Бүлэглэхгүй» (no grouping). */
export function GroupByMenu({ options, active, onChange }: Props) {
  const { t } = useTranslation("common")

  return (
    <Select
      aria-label={t("groupBy.label")}
      leftSection={<Text fz={14} fw={600} c="gray.8" pl="sm" style={{ whiteSpace: "nowrap" }}>{t("groupBy.label")}</Text>}
      leftSectionWidth={96}
      leftSectionPointerEvents="none"
      data={[{ value: NONE, label: t("groupBy.none") }, ...options.map((o) => ({ value: o.key, label: o.label }))]}
      value={active ?? NONE}
      onChange={(v) => onChange(!v || v === NONE ? null : v)}
      allowDeselect={false}
      size="sm"
      radius="md"
      w={240}
    />
  )
}
